import ThronVideo from '@components/utils/ThronVideo';
import Lazyimg from '@components/utils/Lazyimg';
import { getDefferedTransition } from '@utils/landingAnimations';
import useBreakpoint from '@utils/useBreakpoint';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import analytics from '@utils/analytics';
const PromoEditorialCard = (props) => {
    var _a, _b;
    const card = typeof props.card === 'string' ? JSON.parse(props.card) : props.card;
    const videoBg = card.thronID || card.thronMobileID;
    const { t } = useTranslation();
    const currentBreakpoint = useBreakpoint();
    const cardLinkTypeMap = {
        'First CTA': card.link_0,
        'Second CTA': card.link_1,
        'Card Link': card.link,
    };
    const cardLinkTextTypeMap = {
        'First CTA': card.linkText_0_analytics || card.linkText_0,
        'Second CTA': card.linkText_1_analytics || card.linkText_1,
        'Card Link': card.linkText_analytics || card.linkText,
    };
    const ariaHideImageLink = {
        None: false,
        'First CTA': true,
        'Second CTA': true,
        'Card Link': false,
    };
    const [isDesktop, setIsDesktop] = useState(false);
    // gestisco hide/show quick buy su mobile
    useEffect(() => {
        if (currentBreakpoint >= window.mqObj.md) {
            setIsDesktop(true);
        }
        else {
            setIsDesktop(false);
        }
    }, [currentBreakpoint]);
    const handleClick = (clickedCta) => {
        var _a, _b, _c;
        let analyticsTitle = card.title_analytics || card.title;
        analytics.promoEditorialCardsAnalytics(analyticsTitle, clickedCta);
        if ((_a = card.product) === null || _a === void 0 ? void 0 : _a.isMbm) {
            analytics.promoImage('promo tile', (_b = card.product) === null || _b === void 0 ? void 0 : _b.name);
        }
        else if (props.trackingAction) {
            props.trackingAction();
        }
        else if (card.analytics_type == 'vto') {
            analytics.vtoPlpGeneric((_c = card.linkText_0) === null || _c === void 0 ? void 0 : _c.toLowerCase());
        }
    };
    return (React.createElement(motion.div, { transition: getDefferedTransition(isDesktop ? (props.index < 4 ? 0 : 1) : props.index < 2 ? 0 : props.index < 4 ? 1 : 2, true), initial: { opacity: props.index < 8 ? 0 : 1 }, animate: { opacity: props.hasAnimation && !props.startAnimation ? 0 : 1 }, className: classNames('plppromo__div', videoBg && 'plppromo__video') },
        videoBg && (React.createElement("div", { className: "video-container" },
            React.createElement(ThronVideo, { thronID: card.thronID, thronMobileID: card.thronMobileID, autoplay: true, muted: true }),
            React.createElement("button", { className: "btn--pause btn--pause-white", "aria-label": t('button.pause'), "data-pause": true, "aria-pressed": "false" }))),
        React.createElement("div", { className: classNames('plppromo__text-wrapper container no-pointer', videoBg && 'video-card') },
            card.logo && React.createElement("img", { src: card.logo.path, alt: "", className: "plppromo__logo" }),
            card.collection_name && React.createElement("div", { className: "plppromo__collection-name primary-s", dangerouslySetInnerHTML: { __html: card.collection_name } }),
            React.createElement("h3", { id: `promo-card__title-${card.ID}`, className: classNames(card.isWhite ? 'plppromo__title white-title' : 'plppromo__title') }, card.title),
            React.createElement("p", { className: "plppromo__description" }, card.description),
            React.createElement("div", { className: "plppromo__cta-wrapper" },
                card.link_0 && (React.createElement("a", { "aria-describedby": `promo-card__title-${card.ID}`, href: card.link_0, className: "button--secondary-inverted plppromo__cta button", onClick: () => handleClick(card.linkText_0_analytics || card.linkText_0) }, card.linkText_0)),
                card.link_1 && (React.createElement("a", { "aria-describedby": `promo-card__title-${card.ID}`, href: card.link_1, className: "button--secondary-inverted plppromo__cta button", onClick: () => handleClick(card.linkText_1_analytics || card.linkText_1) }, card.linkText_1)))),
        card.link_2 && (React.createElement("a", { "aria-describedby": `promo-card__title-${card.ID}`, href: card.link_2, className: "button button--tertiary button--tertiary-inverted plppromo__bottom-cta", onClick: () => handleClick(card.linkText_2_analytics || card.linkText_2) }, card.linkText_2)),
        !videoBg && (React.createElement("div", { className: classNames(cardLinkTypeMap[card.cardLinkType] ? 'plppromo__link' : 'plppromo__picture-container'), "aria-labelledby": card.title, "tab-index": ariaHideImageLink[card.cardLinkType] ? '-1' : '', "aria-hidden": ariaHideImageLink[card.cardLinkType] },
            React.createElement("picture", { className: classNames('plppromo__picture', card.gradient && 'plppromo__picture--gradient') },
                card.imageM && React.createElement("source", { media: "(min-width:600px)", srcSet: card.imageM.path }),
                React.createElement(Lazyimg, { src: card.image.path, alt: card.image_alt || '', width: (_a = card.image.meta_data) === null || _a === void 0 ? void 0 : _a.width, height: (_b = card.image.meta_data) === null || _b === void 0 ? void 0 : _b.height }))))));
};
export default PromoEditorialCard;
